import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Company } from "../api/models/companies.models";

interface CompanyContractInformationProps {
  company?: Company;
  pipedriveIdentifier?: string;
  procountorIdentifier?: string;
}

const ContractInfoContainer = styled.div`
  margin-bottom: 2rem;
  margin-top: 0;
  padding: 0 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;

  & h3 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 1rem;
  }
`;

const ContractHeader = styled.span`
  font-weight: 500;
  font-size: 0.95rem;
`;

export const CompanyContractInformation: React.FC<
  CompanyContractInformationProps
> = ({ company, pipedriveIdentifier, procountorIdentifier }) => {
  const { t } = useTranslation();

  // Helper function to format date string
  const formatDate = (dateString: string | null) => {
    if (!dateString) return t("label-not-set");

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString(["fi-FI"], {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (error) {
      return t("label-invalid-date");
    }
  };

  if (
    !company ||
    (!company.contractStartDate &&
      !company.contractEndDate &&
      !pipedriveIdentifier &&
      !procountorIdentifier)
  ) {
    return null;
  }

  return (
    <ContractInfoContainer>
      <h3 style={{ marginTop: 0, marginBottom: "1rem" }}>
        {t("label-contract-information")}
      </h3>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "0.5rem",
        }}
      >
        <div>
          <ContractHeader>{t("label-contract-start-date")}:</ContractHeader>{" "}
          {formatDate(company.contractStartDate)}
        </div>
        <div>
          <ContractHeader>{t("label-contract-end-date")}:</ContractHeader>{" "}
          {formatDate(company.contractEndDate)}
        </div>
        {pipedriveIdentifier && (
          <div>
            <ContractHeader>{t("label-pipedrive-identifier")}:</ContractHeader>{" "}
            {pipedriveIdentifier}
          </div>
        )}
        {procountorIdentifier && (
          <div>
            <ContractHeader>{t("label-procountor-identifier")}:</ContractHeader>{" "}
            {procountorIdentifier}
          </div>
        )}
      </div>
    </ContractInfoContainer>
  );
};
